import type { DehydratedState, VueQueryPluginOptions } from '@tanstack/vue-query'
import { VueQueryPlugin, QueryClient, hydrate, dehydrate } from '@tanstack/vue-query'
// Nuxt 3 app aliases
import { defineNuxtPlugin, useState } from '#imports'
import { AxiosError } from 'axios'

export default defineNuxtPlugin({
  name: 'vue-query',
  async setup (nuxt) {
    const vueQueryState = useState<DehydratedState | null>('vue-query')

    // Modify your Vue Query global settings here
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 15 * 60 * 1000, // 30 minutes
          gcTime: 2 * 60 * 1000, // 2 minute
          retry: (failureCount,   error) => {
            if(error instanceof AxiosError) {
              if(error.response && error?.response?.status == 400) {
                return false;
              }
            }

            return failureCount < 3
          }
        },
      },
    })
    const options: VueQueryPluginOptions = { queryClient }

    nuxt.vueApp.use(VueQueryPlugin, options)

    if (process.server) {
      nuxt.hooks.hook('app:rendered', () => {
        vueQueryState.value = dehydrate(queryClient)
      })
    }

    if (process.client) {
      nuxt.hooks.hook('app:created', () => {
        hydrate(queryClient, vueQueryState.value)
      })
    }
  }
})
/*
export default defineNuxtPlugin((nuxt) => {
  const vueQueryState = useState<DehydratedState | null>('vue-query')

  // Modify your Vue Query global settings here
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15 * 60 * 1000, // 30 minutes
        gcTime: 2 * 60 * 1000, // 2 minute
        retry: (failureCount,   error) => {
          if(error instanceof AxiosError) {
            if(error.response && error?.response?.status == 400) {
              return false;
            }
          }

          return failureCount < 3
        }
      },
    },
  })
  const options: VueQueryPluginOptions = { queryClient }

  nuxt.vueApp.use(VueQueryPlugin, options)

  if (process.server) {
    nuxt.hooks.hook('app:rendered', () => {
      vueQueryState.value = dehydrate(queryClient)
    })
  }

  if (process.client) {
    nuxt.hooks.hook('app:created', () => {
      hydrate(queryClient, vueQueryState.value)
    })
  }
})
*/